import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  supportsBulkSummaryToast,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkFindArea = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const { t } = useTranslation();
  const { stopProcessPolling } = useProcesses();
  const bulkFindAreaProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkFindArea,
    entity,
  );
  const bulkFindAreaProcess = useRecoilValue(
    activeProcessSF(bulkFindAreaProcessKey),
  );

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      onComplete,
      entity,
      processTitle: RydeProcessTitle.BulkFindArea,
      process: bulkFindAreaProcess,
      stopProcessPolling,
      translationFunction: t,
      toastSummaryOnComplete: supportsBulkSummaryToast(entity),
    });
  }, [bulkFindAreaProcess, entity, onComplete, stopProcessPolling, t]);
};
